export default "__VITE_ASSET__BEe_P0mG__"